import { render } from "./ReceitasExport.vue?vue&type=template&id=2f6c4ce4"
import script from "./ReceitasExport.vue?vue&type=script&lang=js"
export * from "./ReceitasExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__